<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (unitVoltageSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Unit Voltage:</label>
              <select class="halfWidthInputField" #unitVoltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
                (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
                [value]="unitVoltageSelection.Value.toString()">
                @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (cabinetInsulationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Cabinet Insulation:</label>
              <select class="halfWidthInputField" #cabinetInsulationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
                (change)="selectionChanged(cabinetInsulationSelection, cabinetInsulationInput.value)"
                [value]="cabinetInsulationSelection.Value.toString()">
                @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (blowerMotorSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Blower Motor:</label>
              <select class="halfWidthInputField" #blowerMotorInput
                [class.invalidConfigurationSelection]="isInvalidSelection(blowerMotorSelection.Name)"
                (change)="selectionChanged(blowerMotorSelection, blowerMotorInput.value)"
                [value]="blowerMotorSelection.Value.toString()">
                @for (allowable of blowerMotorSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="blowerMotorSelection.Value && blowerMotorSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sourceWaterCoilSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Source Water Coil:</label>
              <select class="halfWidthInputField" #sourceWaterCoilInput
                [class.invalidConfigurationSelection]="isInvalidSelection(sourceWaterCoilSelection.Name)"
                (change)="selectionChanged(sourceWaterCoilSelection, sourceWaterCoilInput.value)"
                [value]="sourceWaterCoilSelection.Value.toString()">
                @for (allowable of sourceWaterCoilSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="sourceWaterCoilSelection.Value && sourceWaterCoilSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadWaterCoilSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Water Coil:</label>
              <select class="halfWidthInputField" #loadWaterCoilInput
                [class.invalidConfigurationSelection]="isInvalidSelection(loadWaterCoilSelection.Name)"
                (change)="selectionChanged(loadWaterCoilSelection, loadWaterCoilInput.value)"
                [value]="loadWaterCoilSelection.Value.toString()">
                @for (allowable of loadWaterCoilSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="loadWaterCoilSelection.Value && loadWaterCoilSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (optionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Options:</label>
              <select class="halfWidthInputField" #optionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(optionsSelection.Name)"
                (change)="selectionChanged(optionsSelection, optionsInput.value)"
                [value]="optionsSelection.Value.toString()">
                @for (allowable of optionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="optionsSelection.Value && optionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
